import { css } from 'emotion';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { inject } from 'dependable-react';

import { I18N_TOKEN } from '../services/InjectTokens';

const select = css`
  box-sizing: border-box;
  width: 100%;
  height: 50px;

  font-family: 'Nunito', sans-serif;
  font-size: 15px;

  border: solid 1px #bfbcbc;
  border-radius: 25px;
  padding-left: 40px;

  outline: none;

  -webkit-appearance: none;
  cursor: pointer;
`;

const label = css`
  position: absolute;
  font-size: 15px;
  cursor: text;

  left: 41px;
  top: 15px;

  color: #9e9e9e;

  transform: scale(0.9) translateY(-27px) translateX(-16px);
  background: #ffffff;
  padding: 0 10px;
`;

const wrapper = css`
  position: relative;
  cursor: pointer;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    display: block;
    transform: rotate(45deg);
    border-bottom: 2px solid #959595;
    border-right: 2px solid #959595;
    position: absolute;
    right: 30px;
    top: 15px;
  }
`;

interface IProps {
  values: Array<{ value?: string; name: string }>;
  selected: string;
  onChange(e: React.ChangeEvent<HTMLSelectElement>): void;
}

export const Select = observer(({ values, selected, onChange }: IProps) => {
  const i18n = inject(I18N_TOKEN);
  return (
    <div className={wrapper}>
      <select id="languageSelector" className={select} onChange={onChange} value={selected}>
        {values.map(({ value, name }) => (
          <option key={value || name} value={value} disabled={!value} aria-selected={selected === value}>
            {name}
          </option>
        ))}
      </select>
      <label id="languageSelector" htmlFor="languageSelector" className={label}>
        {i18n.t('language_picker_label')}
      </label>
    </div>
  );
});
